import { render, staticRenderFns } from "./DocumentList.vue?vue&type=template&id=643a479e"
import script from "./DocumentList.vue?vue&type=script&lang=ts"
export * from "./DocumentList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports